module.exports = __webpack_public_path__ + "static/media/REACT.d41d8cd9.md";